var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chartContainer"},[_c('vue-apex-charts',{ref:"chart",attrs:{"type":"bar","width":"450","height":"500","series":_vm.series,"options":_vm.chartOptions},on:{"dataPointSelection":_vm.dataPointSelectionHandler}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }